import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import ContactDataTable from '../../components/ContactDataTable';
const defaultTheme = createTheme();

const ManageContact = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <ContactDataTable />
    </ThemeProvider>
  );
}

export default ManageContact;